import Footer from "../../components/footer/footer";
import Header from "../../components/header/header";

export default function Gallery() {
    return (
        <div className="flex flex-col w-full h-full">
            <Header />
                <div className="flex justify-center items-center min-h-screen font-bold">
                    Gallery page is under construction.
                </div>
            <Footer />
        </div>

    )
}